import { setLocale } from 'yup'

setLocale({
    mixed: {
        required: ({ path }) => ({ key: path, value: 'Поле обязательно' })
    }
})